<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    楼村站<br>
站点介绍<br>
楼村站位于规划的公园大道与楼环路交叉路口以西，站点位置处及南北侧主要有为园地、牲畜养殖场：东南侧为中央公园：西侧主要为大量的工业厂房。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
科学馆	06:37	23:16	6号线	3分24秒	6分20秒<br>
松岗	06:09	23:55	6号线	3分24秒	6分20秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
科学馆	06:36	23:16	6号线	4分45秒	6分钟<br>
松岗	06:09	23:55	6号线	4分45秒	6分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
科学馆	06:36	00:16	6号线	4分45秒	6分钟<br>
松岗	06:09	00:55	6号线	4分45秒	6分钟<br><br>
<br>
站点出口信息<br><br>
B出入口:<br>
楼明路<br><br>
C出入口:<br>
楼明路<br><br>
A出入口:<br>
科学大道<br><br>
D出入口:<br>
科学大道<br><br>
公交换乘信息<br><br>
C出入口:<br>
公交站名： 楼村<br>
720，E15，接驳专线2<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "liuhaoxian",
          title: "6号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>